<script setup lang="ts">
const { t } = useTexts();

useSeo({
  title: t('account.history.full.title'),
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-history"
    :title="$t('account.history.full.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions show-only-this-tab="full" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
